import React from 'react';
import { Select } from '~/components';

export const SelectSymbol: React.VFC<{
  onChangeValue: (v: any) => void;
  value: number;
}> = ({ onChangeValue, value }) => {
  const options = [
    { value: 1, label: '>' },
    { value: 2, label: '>=' },
    { value: 3, label: '=' },
    { value: 4, label: '<' },
    { value: 5, label: '<=' },
  ];
  return (
    <Select
      value={value}
      name="symbol"
      fontSize="15px"
      onChange={e => onChangeValue(e.target.value)}
      width="80px"
    >
      {options?.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Select>
  );
};
